<template>
  <layout>
    <template v-slot:header>
      <h2>Edit Footer Message</h2>
      <BreadCrumbs activeItem="Edit Footer Message" :crumbs="{ home: 'Dashboard', footer_messages: 'Footer Messages'}"/>
      <flash-messages />
      <AppHead title="Edit Footer Message" />
    </template>

    <template v-slot:default>
      <form @submit.prevent="update">
        <div class="row mb-3">
          <div class="col-12 col-lg-6 mb-3 mb-lg-0">
            <card class="h-100" title="Footer Message Info">
              <div class="row">
                <div class="form-group col-12 col-xl-6">
                  <jet-label for="message" value="Message" />
                  <textarea id="message" type="textarea" class="form-control" v-model="form.message" />
                  <jet-input-error :message="form.errors.message" class="mt-2" />
                </div>
              </div>
            </card>
          </div>
        </div>

        <div class="bottom-button mt-4">
          <jet-button class="px-5" btnStyle="success" :disable="form.processing" type="submit">Edit Footer Message</jet-button>
        </div>
      </form>
    </template>
  </layout>
</template>

<script>
import Layout from '@/Shared/Admin/Layout'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'

import FlashMessages from '@/Shared/FlashMessages'
import JetButton from '@/Jetstream/Button'
import JetFormSection from '@/Jetstream/FormSection'
import JetInput from '@/Jetstream/Input'
import JetCheckbox from '@/Jetstream/Checkbox'
import JetInputError from '@/Jetstream/InputError'
import JetLabel from '@/Jetstream/Label'
import JetActionMessage from '@/Jetstream/ActionMessage'
import JetDialogModal from '@/Jetstream/DialogModal'
import JetDangerButton from '@/Jetstream/DangerButton'
import BreadCrumbs from '@/Shared/BreadCrumbs'

export default {
  components: {
    FileInput,
    SelectInput,
    TextInput,
    JetActionMessage,
    JetButton,
    JetFormSection,
    JetInput,
    JetCheckbox,
    JetInputError,
    JetLabel,
    JetDialogModal,
    JetDangerButton,
    Layout,
    FlashMessages,
    BreadCrumbs
  },
  remember: 'form',
  props: {
    footer_message: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        message: this.footer_message.message
      }),
    }
  },
  mounted() {
    
  },
  methods: {
    update() {
      this.form.post(this.route('footer_messages.update', this.footer_message.id))
    },
  },
}
</script>
